import React, { useState, useEffect } from 'react'
import ReduceBigNumbers from './ReduceBigNumbers'

const PlayerAction = ({ currentPlayer, time, action, currentBet }) => {
  const [ timerCount, setTimerCount ] = useState ( null )
  const [ playerAction, setPlayerAction ] = useState ( null )

  let turnTimer = null

  useEffect (() => {
    setTurnTimer()
    setupAction( action )

    function setupAction( action ){
      switch( action ){

        case 'check': setPlayerAction( 'actionCheck' )
        break 
        case 'bet': setPlayerAction( 'actionBet' )
        break 
        case 'fold': setPlayerAction( 'actionFold' )
        break 
        case 'call': setPlayerAction( 'actionCall' )
        break 
        case 'raise': setPlayerAction( 'actionRaise' ) 
        break 
        case 'allIn': setPlayerAction( 'actionAllIn' ) 
        break 
        default: setPlayerAction( '' )
        break
      }
    }

    return ()=>{
      stopTurnTimer()
    }
  }, [ currentPlayer, action ])

  const setTurnTimer = () => {
    if ( !turnTimer ){
        setTimerCount( time )
        turnTimer = setInterval(() => {
            if ( timerCount >= 1 ) {
                setTimerCount(( prevCount )=>  prevCount >= 1 ? prevCount - 1 : prevCount)
            } else {
                stopTurnTimer()
            }
      }, 1000 )
    }
  };

  const stopTurnTimer = () => {
    clearInterval( turnTimer )
    turnTimer = null
  }

  const renderAction = () => {
    if ( currentPlayer ) {
      if ( timerCount < 8 ) {
        return (
          <div className='action'>
            <span className='turnTimer'>{ timerCount }</span>
            { currentBet ?
              <p className='betAction'>
                { currentBet > 0 && action !== 'fold' ? "$ " + currentBet : null }
              </p>
              : null
            }
          </div>
        )

      } else {
        return (
          <div className='action'>
            <div className='bouncer'>
              <div></div>
              <div></div>
              <div></div>
            </div>
            { currentBet ?
              <p className='betAction'>
                { currentBet > 0 && action !== 'fold' ? "$ " + currentBet : null }
              </p>
              : null
            }
          </div>
        )
      }
    } else {
      return (
        <div className='action'>
          { action ? <p className='actionName'>{ action }</p> : null }
          { currentBet ? <p className='betAction'>{ currentBet > 0 && action !== 'fold' ? "$ " + ReduceBigNumbers( currentBet ) : null }</p> : null }
        </div>
      )
    }
  }
  return <div className='actionWrapper'>{ renderAction() }{ action ? <div className={ 'actionBackground ' + playerAction }></div> : <div className='actionBackgroundTransparent'></div> }</div>
}

export default PlayerAction